import React from 'react';

const Datenschutz: React.FC = () => {
  return (
    <div className="page-container" style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={titleStyle}>Datenschutzerklärung</h1>
        
        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>1. Datenschutz auf einen Blick</h2>
          
          <h3 style={subSectionTitleStyle}>Allgemeine Hinweise</h3>
          <p style={textStyle}>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
            passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
            persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen 
            Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </p>

          <h3 style={subSectionTitleStyle}>Datenerfassung auf dieser Website</h3>
          <p style={textStyle}>
            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
            können Sie dem Impressum dieser Website entnehmen.
          </p>
          <p style={textStyle}>
            <strong>Wie erfassen wir Ihre Daten?</strong><br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um 
            Daten handeln, die Sie in ein Kontaktformular eingeben oder bei der Registrierung angeben.
          </p>
          <p style={textStyle}>
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
            IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder 
            Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </p>
          <p style={textStyle}>
            <strong>Wofür nutzen wir Ihre Daten?</strong><br />
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
            Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>
          <p style={textStyle}>
            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer 
            gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung 
            oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt 
            haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das 
            Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten 
            zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>2. Hosting</h2>
          <p style={textStyle}>
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </p>
          <p style={textStyle}>
            <strong>Externes Hosting</strong><br />
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, 
            werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei kann es sich v.a. um IP-Adressen, 
            Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe 
            und sonstige Daten, die über eine Website generiert werden, handeln.
          </p>
          <p style={textStyle}>
            Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und 
            bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und 
            effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>3. Allgemeine Hinweise und Pflichtinformationen</h2>
          
          <h3 style={subSectionTitleStyle}>Datenschutz</h3>
          <p style={textStyle}>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
            personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie 
            dieser Datenschutzerklärung.
          </p>
          <p style={textStyle}>
            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene 
            Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende 
            Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, 
            wie und zu welchem Zweck das geschieht.
          </p>

          <h3 style={subSectionTitleStyle}>Hinweis zur verantwortlichen Stelle</h3>
          <p style={textStyle}>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p style={textStyle}>
            <strong>VoyagePlanner GmbH</strong><br />
            Sven Mahn<br />
            Saseler Damm 43-45<br />
            22395 Hamburg<br />
            Deutschland
          </p>
          <p style={textStyle}>
            Telefon: <a href="tel:+4940226348012" style={linkStyle}>040 226 348 012</a><br />
            E-Mail: <a href="mailto:kontakt@voyageplanner.app" style={linkStyle}>kontakt@voyageplanner.app</a>
          </p>
          <p style={textStyle}>
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen 
            über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) 
            entscheidet.
          </p>

          <h3 style={subSectionTitleStyle}>Speicherdauer</h3>
          <p style={textStyle}>
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben 
            Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein 
            berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, 
            werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung 
            Ihrer personenbezogenen Daten haben (z.B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im 
            letztgenannten Fall erfolgt die Löschung nach Fortfall dieser Gründe.
          </p>

          <h3 style={subSectionTitleStyle}>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
          <p style={textStyle}>
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine 
            bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten 
            Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>

          <h3 style={subSectionTitleStyle}>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
          <p style={textStyle}>
            Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer 
            Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes 
            oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger 
            verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
          </p>

          <h3 style={subSectionTitleStyle}>Recht auf Datenübertragbarkeit</h3>
          <p style={textStyle}>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags 
            automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format 
            aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen 
            verlangen, erfolgt dies nur, soweit es technisch machbar ist.
          </p>

          <h3 style={subSectionTitleStyle}>Auskunft, Löschung und Berichtigung</h3>
          <p style={textStyle}>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche 
            Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck 
            der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu 
            weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>4. Datenerfassung auf dieser Website</h2>
          
          <h3 style={subSectionTitleStyle}>Server-Log-Dateien</h3>
          <p style={textStyle}>
            Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
            die Ihr Browser automatisch an uns übermittelt. Dies sind:
          </p>
          <ul style={listStyle}>
            <li style={listItemStyle}>Browsertyp und Browserversion</li>
            <li style={listItemStyle}>verwendetes Betriebssystem</li>
            <li style={listItemStyle}>Referrer URL</li>
            <li style={listItemStyle}>Hostname des zugreifenden Rechners</li>
            <li style={listItemStyle}>Uhrzeit der Serveranfrage</li>
            <li style={listItemStyle}>IP-Adresse</li>
          </ul>
          <p style={textStyle}>
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
          </p>
          <p style={textStyle}>
            Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat 
            ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – 
            hierzu müssen die Server-Log-Files erfasst werden.
          </p>

          <h3 style={subSectionTitleStyle}>Kontaktformular</h3>
          <p style={textStyle}>
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
            inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
            von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p style={textStyle}>
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage 
            mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen 
            erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an 
            der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer 
            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
          </p>

          <h3 style={subSectionTitleStyle}>Registrierung auf dieser Website</h3>
          <p style={textStyle}>
            Sie können sich auf dieser Website registrieren, um zusätzliche Funktionen auf der Seite zu nutzen. Die 
            dazu eingegebenen Daten verwenden wir nur zum Zwecke der Nutzung des jeweiligen Angebotes oder Dienstes, 
            für den Sie sich registriert haben. Die bei der Registrierung abgefragten Pflichtangaben müssen vollständig 
            angegeben werden. Anderenfalls werden wir die Registrierung ablehnen.
          </p>
          <p style={textStyle}>
            Für wichtige Änderungen etwa beim Angebotsumfang oder bei technisch notwendigen Änderungen nutzen wir die 
            bei der Registrierung angegebene E-Mail-Adresse, um Sie auf diesem Wege zu informieren.
          </p>
          <p style={textStyle}>
            Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt zum Zwecke der Durchführung des 
            durch die Registrierung begründeten Nutzungsverhältnisses und ggf. zur Anbahnung weiterer Verträge 
            (Art. 6 Abs. 1 lit. b DSGVO).
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={sectionTitleStyle}>5. Plugins und Tools</h2>
          
          <h3 style={subSectionTitleStyle}>Google OAuth</h3>
          <p style={textStyle}>
            Diese Website nutzt Google OAuth für die Benutzerauthentifizierung. Anbieter ist die Google Ireland Limited 
            („Google"), Gordon House, Barrow Street, Dublin 4, Irland.
          </p>
          <p style={textStyle}>
            Wenn Sie sich über Google OAuth anmelden, werden bestimmte Daten von Google an uns übermittelt (z.B. Name, 
            E-Mail-Adresse, Profilbild). Diese Daten werden ausschließlich zur Authentifizierung und Verwaltung Ihres 
            Benutzerkontos verwendet.
          </p>
          <p style={textStyle}>
            Die Nutzung von Google OAuth erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO. Weitere Informationen 
            zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von Google:{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
              https://policies.google.com/privacy
            </a>
          </p>
        </section>

        <section style={sectionStyle}>
          <p style={textStyle}>
            <em>Quelle: eRecht24</em>
          </p>
        </section>
      </div>
    </div>
  );
};

// Styles
const containerStyle: React.CSSProperties = {
  minHeight: '100vh',
  backgroundColor: '#f8f9fa',
  padding: '2rem 1rem',
};

const contentStyle: React.CSSProperties = {
  maxWidth: '900px',
  margin: '0 auto',
  backgroundColor: 'white',
  padding: '3rem',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

const titleStyle: React.CSSProperties = {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: '#2c3e50',
  marginBottom: '2rem',
  borderBottom: '3px solid #3498db',
  paddingBottom: '1rem',
};

const sectionStyle: React.CSSProperties = {
  marginBottom: '2.5rem',
};

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '1.5rem',
  fontWeight: '600',
  color: '#34495e',
  marginBottom: '1rem',
  marginTop: '1.5rem',
};

const subSectionTitleStyle: React.CSSProperties = {
  fontSize: '1.2rem',
  fontWeight: '600',
  color: '#555',
  marginBottom: '0.75rem',
  marginTop: '1rem',
};

const textStyle: React.CSSProperties = {
  fontSize: '1rem',
  lineHeight: '1.8',
  color: '#555',
  marginBottom: '1rem',
};

const linkStyle: React.CSSProperties = {
  color: '#3498db',
  textDecoration: 'none',
  fontWeight: '500',
};

const listStyle: React.CSSProperties = {
  marginLeft: '2rem',
  marginBottom: '1rem',
};

const listItemStyle: React.CSSProperties = {
  fontSize: '1rem',
  lineHeight: '1.8',
  color: '#555',
  marginBottom: '0.5rem',
};

export default Datenschutz;

